/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * DRM scheme identifiers supported on web platforms.
 * Used in {TPlayerDrmConfig} container.
 */
export enum DrmType {
  /**
   * Apple FairPlay Streaming — supported on Safari (macOS/iOS).
   */
  FairPlay = "fairplay",

  /**
   * MobiFairPlay(Apple FairPlay Streaming) — supported on Safari (macOS/iOS).
   */
  MobiFairPlay = "mobiFairPlay",

  /**
   * MobiWidevine(Google Widevine) — supported on Chrome, Firefox, Edge, Smart TVs.
   */
  MobiWidevine = "mobiWidevine",

  /**
   * Google Widevine — supported on Chrome, Firefox, Edge, Smart TVs.
   */
  Widevine = "widevine",

  /**
   * Unencrypted content — no DRM applied.
   */
  Clear = "clear"
}
